export class boxRequest{

  constructor(
  public currency_id?: number,
  public mount?: number
  ){}
}
